module.exports = __webpack_public_path__ + "94a4915c95354061a5906196c4e369b5.svg";